import locationProvider from '@/providers/location'

/**
 * Declare Variable
 */
const state = {
  location: null,

  locationState: null,

  locationDetail: {
    visibleItem: 'locationDetail'
  },

  defaultOpeningHours: [],

  exceptionOpeningHours: [],

  locationsPageState: {
    page: 1,
    searchTerm: "",
    channelId: 0,
    countryId: 0,
    itemsPerPage: 50,
    activationStatus: -2,
    publishStatus: -1
  },
};

const getters = {
  locationId: state => state.locationState.Id ?? 0,
  locationName: (state) => state.locationState?.Name ?? '',
  getLocation: (state) => state.location,
  getLocationState: (state) => state.locationState,
  getLocationDetail: (state) => state.locationDetail,
  getLocationsPageState: (state) => state.locationsPageState,
  getDefaultOpeningHours: state => state.defaultOpeningHours,
  getExceptionOpeningHours: state => state.exceptionOpeningHours,
};

const actions = {
  async getLocationState(vueContext, locationId = 0) {
    if (locationId === 0) { return }

    try {
      const response = await locationProvider.methods.getLocationState(locationId)
      if (response.status === 200) {
        vueContext.commit('setLocationState', response.data)
      }
    }
    catch {
    }
  },

  async getLocation(vueContext, locationId = 0) {
    if (locationId === 0) { return }

    try {
      const response = await locationProvider.methods.getLocationById(locationId)
      if (response.status === 200) {
        vueContext.commit('setLocation', response.data)
      }
    }
    catch {
    }
  }
};

const mutations = {
  setLocation: (state, location) => {
    state.location = location;
  },

  setLocationState: (state, locationState) => {
    state.locationState = locationState;
  },

  setLocationDetail: (state, locationDetail) => {
    state.locationDetail = locationDetail;
  },

  setLocationsPageState: (state, locationsPageState) => {
    state.locationsPageState = locationsPageState;
  },

  setDefaultOpeningHours(state, newState) {
    state.defaultOpeningHours = newState
  },

  setExceptionOpeningHours(state, newState) {
    state.exceptionOpeningHours = newState
  }
};

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
